import * as R from 'ramda';
import {
  INSERT_TYPE_BLANK,
  INSERT_TURBO_QUAD_OVAL,
  INSERT_TURBO_QUAD_POWER_OVAL,
  INSERT_TURBO_QUAD_2_OVAL_NUBS,
  INSERT_TURBO_QUAD_2_SEMI,
  INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  INSERT_TURBO_QUAD_CLASSIC_OVAL,
  INSERT_TURBO_QUAD_SB_POWER_LIFT,
  INSERT_TURBO_QUAD_SB_SEMI,
  INSERT_TURBO_MISS_QUAD_OVAL,
  INSERT_TURBO_MISS_QUAD_POWER_OVAL,
  INSERT_CONTOUR_SUPERSOFT,
  INSERT_CONTOUR_SEMI_CERISE,
  INSERT_CONTOUR_SILICONE,
  INSERT_VISE_POWER_LIFT,
  INSERT_VISE_SEMI,
  INSERT_VISE_SEMI_7_8,
  INSERT_VISE_POWER_OVAL,
  INSERT_VISE_OVAL,
  INSERT_VISE_OVAL_7_8,
  INSERT_VISE_SILICONE,
  INSERT_VISE_GRAPE_NUBS,
  INSERT_VISE_POWER_LIFT_7_8,
  INSERT_VISE_POWER_OVAL_7_8,
  INSERT_ULTIMATE_TLO_OVAL,
  INSERT_ULTIMATE_TLO_LIFT,
  INSERT_ULTIMATE_TLO_OVAL_7_8,
  INSERT_ULTIMATE_TLO_LIFT_7_8,
} from './idx_data_insert_types';

// INSERT_TYPE_BLANK
let order = 0;
let i = 0;
let d = 1;

const idx_data_insert_sizesRAW = [];

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TYPE_BLANK,
  size: '---',
  od: '',
});

for (let j = 0; j <= 1; j++) {
  if (j > 0) {
    i = j;
  } else {
    i = '';
  }

  if (i == 1) {
    d = 0;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + '',
      od: i + '',
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + ' 1/64',
      od: i + ' 1/64',
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + ' 1/32',
      od: i + ' 1/32',
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + ' 3/64',
      od: i + ' 3/64',
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + ' 1/16',
      od: i + ' 1/16',
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + ' 5/64',
      od: i + ' 5/64',
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + ' 3/32',
      od: i + ' 3/32',
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + ' 7/64',
      od: i + ' 7/64',
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + ' 1/8',
      od: i + ' 1/8',
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + ' 9/64',
      od: i + ' 9/64',
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + ' 5/32',
      od: i + ' 5/32',
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + ' 11/64',
      od: i + ' 11/64',
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + ' 3/16',
      od: i + ' 3/16',
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + ' 13/64',
      od: i + ' 13/64',
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + ' 7/32',
      od: i + ' 7/32',
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + ' 15/64',
      od: i + ' 15/64',
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + ' 1/4',
      od: i + ' 1/4',
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + ' 17/64',
      od: i + ' 17/64',
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + ' 9/32',
      od: i + ' 9/32',
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + ' 19/64',
      od: i + ' 19/64',
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + ' 5/16',
      od: i + ' 5/16',
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + ' 21/64',
      od: i + ' 21/64',
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + ' 11/32',
      od: i + ' 11/32',
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + ' 23/64',
      od: i + ' 23/64',
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + ' 3/8',
      od: i + ' 3/8',
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + ' 25/32',
      od: i + ' 25/32',
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + ' 13/32',
      od: i + ' 13/32',
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + ' 27/64',
      od: i + ' 27/64',
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + ' 7/16',
      od: i + ' 7/16',
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + ' 29/64',
      od: i + ' 29/64',
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + ' 15/32',
      od: i + ' 15/32',
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + ' 31/64',
      od: i + ' 31/64',
    });
    order++;
    d++;
  }

  d = 32;
  idx_data_insert_sizesRAW.push({
    type_id: INSERT_TYPE_BLANK,
    size: i + ' 1/2',
    od: i + ' 1/2',
  });
  order++;
  d++;

  if (i == 0) {
    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + ' 33/64',
      od: i + ' 33/64',
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + ' 17/32',
      od: i + ' 17/32',
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + ' 35/64',
      od: i + ' 35/64',
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + ' 9/16',
      od: i + ' 9/16',
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + ' 37/64',
      od: i + ' 37/64',
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + ' 19/32',
      od: i + ' 19/32',
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + ' 39/64',
      od: i + ' 39/64',
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + ' 5/8',
      od: i + ' 5/8',
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + ' 41/64',
      od: i + ' 41/64',
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + ' 21/32',
      od: i + ' 21/32',
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + ' 43/64',
      od: i + ' 43/64',
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + ' 11/16',
      od: i + ' 11/16',
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + ' 45/64',
      od: i + ' 45/64',
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + ' 23/32',
      od: i + ' 23/32',
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + ' 47/64',
      od: i + ' 47/64',
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + ' 3/4',
      od: i + ' 3/4',
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + ' 49/64',
      od: i + ' 49/64',
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + ' 25/32',
      od: i + ' 25/32',
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + ' 51/64',
      od: i + ' 51/64',
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + ' 13/16',
      od: i + ' 13/16',
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + ' 53/64',
      od: i + ' 53/64',
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + ' 27/32',
      od: i + ' 27/32',
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + ' 55/64',
      od: i + ' 55/64',
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + ' 7/8',
      od: i + ' 7/8',
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + ' 57/64',
      od: i + ' 57/64',
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + ' 29/32',
      od: i + ' 29/32',
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + ' 59/64',
      od: i + ' 59/64',
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + ' 15/16',
      od: i + ' 15/16',
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + ' 61/64',
      od: i + ' 61/64',
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + ' 31/32',
      od: i + ' 31/32',
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + ' 63/64',
      od: i + ' 63/64',
    });
    order++;
    d++;
  }
}

// INSERT_TURBO_QUAD_OVAL
idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_OVAL,
  size: '---',
  od: '',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_OVAL,
  size: '19/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_OVAL,
  size: '39/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_OVAL,
  size: '5/8',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_OVAL,
  size: '41/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_OVAL,
  size: '21/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_OVAL,
  size: '43/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_OVAL,
  size: '11/16',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_OVAL,
  size: '45/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_OVAL,
  size: '23/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_OVAL,
  size: '47/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_OVAL,
  size: '3/4',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_OVAL,
  size: '49/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_OVAL,
  size: '25/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_OVAL,
  size: '51/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_OVAL,
  size: '13/16',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_OVAL,
  size: '53/64',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_OVAL,
  size: '27/32',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_OVAL,
  size: '55/64',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_OVAL,
  size: '7/8',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_OVAL,
  size: '57/64',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_OVAL,
  size: '29/32',
  od: '1 1/32',
});

// INSERT_TURBO_QUAD_POWER_OVAL
idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_POWER_OVAL,
  size: '---',
  od: '',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_POWER_OVAL,
  size: '19/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_POWER_OVAL,
  size: '39/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_POWER_OVAL,
  size: '5/8',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_POWER_OVAL,
  size: '41/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_POWER_OVAL,
  size: '21/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_POWER_OVAL,
  size: '43/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_POWER_OVAL,
  size: '11/16',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_POWER_OVAL,
  size: '45/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_POWER_OVAL,
  size: '23/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_POWER_OVAL,
  size: '47/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_POWER_OVAL,
  size: '3/4',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_POWER_OVAL,
  size: '49/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_POWER_OVAL,
  size: '25/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_POWER_OVAL,
  size: '51/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_POWER_OVAL,
  size: '13/16',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_POWER_OVAL,
  size: '53/64',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_POWER_OVAL,
  size: '27/32',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_POWER_OVAL,
  size: '55/64',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_POWER_OVAL,
  size: '7/8',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_POWER_OVAL,
  size: '57/64',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_POWER_OVAL,
  size: '29/32',
  od: '1 1/32',
});

// INSERT_TURBO_QUAD_2_OVAL_NUBS
idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
  size: '---',
  od: '',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
  size: '19/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
  size: '39/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
  size: '5/8',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
  size: '41/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
  size: '21/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
  size: '43/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
  size: '11/16',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
  size: '45/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
  size: '23/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
  size: '47/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
  size: '3/4',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
  size: '49/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
  size: '25/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
  size: '51/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
  size: '13/16',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
  size: '53/64',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
  size: '27/32',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
  size: '55/64',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
  size: '7/8',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
  size: '57/64',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
  size: '29/32',
  od: '1 1/32',
});

// INSERT_TURBO_QUAD_2_SEMI
idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_SEMI,
  size: '---',
  od: '',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_SEMI,
  size: '19/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_SEMI,
  size: '39/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_SEMI,
  size: '5/8',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_SEMI,
  size: '41/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_SEMI,
  size: '21/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_SEMI,
  size: '43/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_SEMI,
  size: '11/16',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_SEMI,
  size: '45/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_SEMI,
  size: '23/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_SEMI,
  size: '47/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_SEMI,
  size: '3/4',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_SEMI,
  size: '49/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_SEMI,
  size: '25/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_SEMI,
  size: '51/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_SEMI,
  size: '13/16',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_SEMI,
  size: '53/64',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_SEMI,
  size: '27/32',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_SEMI,
  size: '55/64',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_SEMI,
  size: '7/8',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_SEMI,
  size: '57/64',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_SEMI,
  size: '29/32',
  od: '1 1/32',
});

// INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT
idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  size: '---',
  od: '',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  size: '19/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  size: '39/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  size: '5/8',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  size: '41/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  size: '21/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  size: '43/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  size: '11/16',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  size: '45/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  size: '23/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  size: '47/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  size: '3/4',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  size: '49/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  size: '25/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  size: '51/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  size: '13/16',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  size: '53/64',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  size: '27/32',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  size: '55/64',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  size: '7/8',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  size: '57/64',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  size: '29/32',
  od: '1 1/32',
});

// INSERT_TURBO_QUAD_CLASSIC_OVAL
idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
  size: '---',
  od: '',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
  size: '19/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
  size: '39/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
  size: '5/8',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
  size: '41/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
  size: '21/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
  size: '43/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
  size: '11/16',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
  size: '45/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
  size: '23/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
  size: '47/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
  size: '3/4',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
  size: '49/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
  size: '25/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
  size: '51/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
  size: '13/16',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
  size: '53/64',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
  size: '27/32',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
  size: '55/64',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
  size: '7/8',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
  size: '57/64',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
  size: '29/32',
  od: '1 1/32',
});

// INSERT_TURBO_QUAD_SB_POWER_LIFT
idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
  size: '---',
  od: '',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
  size: '19/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
  size: '39/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
  size: '5/8',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
  size: '41/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
  size: '21/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
  size: '43/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
  size: '11/16',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
  size: '45/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
  size: '23/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
  size: '47/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
  size: '3/4',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
  size: '49/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
  size: '25/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
  size: '51/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
  size: '13/16',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
  size: '53/64',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
  size: '27/32',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
  size: '55/64',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
  size: '7/8',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
  size: '57/64',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
  size: '29/32',
  od: '1 1/32',
});

// INSERT_TURBO_QUAD_SB_SEMI
idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_SEMI,
  size: '---',
  od: '',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_SEMI,
  size: '19/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_SEMI,
  size: '39/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_SEMI,
  size: '5/8',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_SEMI,
  size: '41/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_SEMI,
  size: '21/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_SEMI,
  size: '43/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_SEMI,
  size: '11/16',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_SEMI,
  size: '45/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_SEMI,
  size: '23/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_SEMI,
  size: '47/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_SEMI,
  size: '3/4',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_SEMI,
  size: '49/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_SEMI,
  size: '25/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_SEMI,
  size: '51/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_SEMI,
  size: '13/16',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_SEMI,
  size: '53/64',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_SEMI,
  size: '27/32',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_SEMI,
  size: '55/64',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_SEMI,
  size: '7/8',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_SEMI,
  size: '57/64',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_SEMI,
  size: '29/32',
  od: '1 1/32',
});

// INSERT_TURBO_MISS_QUAD_OVAL
idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_OVAL,
  size: '---',
  od: '',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_OVAL,
  size: '17/32',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_OVAL,
  size: '35/64',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_OVAL,
  size: '9/16',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_OVAL,
  size: '37/64',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_OVAL,
  size: '19/32',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_OVAL,
  size: '39/64',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_OVAL,
  size: '5/8',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_OVAL,
  size: '41/64',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_OVAL,
  size: '21/32',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_OVAL,
  size: '43/64',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_OVAL,
  size: '11/16',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_OVAL,
  size: '45/64',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_OVAL,
  size: '23/32',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_OVAL,
  size: '47/64',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_OVAL,
  size: '3/4',
  od: '7/8',
});

// INSERT_TURBO_MISS_QUAD_POWER_OVAL
idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_POWER_OVAL,
  size: '---',
  od: '',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_POWER_OVAL,
  size: '17/32',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_POWER_OVAL,
  size: '35/64',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_POWER_OVAL,
  size: '9/16',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_POWER_OVAL,
  size: '37/64',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_POWER_OVAL,
  size: '19/32',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_POWER_OVAL,
  size: '39/64',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_POWER_OVAL,
  size: '5/8',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_POWER_OVAL,
  size: '41/64',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_POWER_OVAL,
  size: '21/32',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_POWER_OVAL,
  size: '43/64',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_POWER_OVAL,
  size: '11/16',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_POWER_OVAL,
  size: '45/64',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_POWER_OVAL,
  size: '23/32',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_POWER_OVAL,
  size: '47/64',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_POWER_OVAL,
  size: '3/4',
  od: '7/8',
});

// INSERT_CONTOUR_SUPERSOFT
idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SUPERSOFT,
  size: '---',
  od: '',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SUPERSOFT,
  size: '19/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SUPERSOFT,
  size: '5/8',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SUPERSOFT,
  size: '21/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SUPERSOFT,
  size: '11/16',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SUPERSOFT,
  size: '23/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SUPERSOFT,
  size: '3/4',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SUPERSOFT,
  size: '25/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SUPERSOFT,
  size: '13/16',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SUPERSOFT,
  size: '27/32',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SUPERSOFT,
  size: '7/8',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SUPERSOFT,
  size: '29/32',
  od: '1 1/32',
});

// INSERT_CONTOUR_SEMI_CERISE
idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SEMI_CERISE,
  size: '---',
  od: '',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SEMI_CERISE,
  size: '19/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SEMI_CERISE,
  size: '5/8',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SEMI_CERISE,
  size: '21/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SEMI_CERISE,
  size: '11/16',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SEMI_CERISE,
  size: '23/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SEMI_CERISE,
  size: '3/4',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SEMI_CERISE,
  size: '25/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SEMI_CERISE,
  size: '13/16',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SEMI_CERISE,
  size: '27/32',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SEMI_CERISE,
  size: '7/8',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SEMI_CERISE,
  size: '29/32',
  od: '1 1/32',
});

// INSERT_CONTOUR_SILICONE
idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SILICONE,
  size: '---',
  od: '',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SILICONE,
  size: '19/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SILICONE,
  size: '5/8',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SILICONE,
  size: '21/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SILICONE,
  size: '11/16',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SILICONE,
  size: '23/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SILICONE,
  size: '3/4',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SILICONE,
  size: '25/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SILICONE,
  size: '13/16',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SILICONE,
  size: '27/32',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SILICONE,
  size: '7/8',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SILICONE,
  size: '29/32',
  od: '1 1/32',
});

// INSERT_VISE_POWER_LIFT
idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: '---',
  od: '',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: '0: 9/16',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: '0.5: 37/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: '1: 19/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: '1.5: 39/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: '2: 5/8',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: '2.5: 41/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: '3: 21/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: '3.5: 43/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: '4: 11/16',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: '4.5: 45/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: '5: 23/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: '5.5: 47/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: '6: 3/4',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: '6.5: 49/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: '7: 25/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: '7.5: 51/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: '8: 13/16',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: '8.5: 53/64',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: '9: 27/32',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: '9.5: 55/64',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: '10: 7/8',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: '10.5: 57/64',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: '11: 29/32',
  od: '1 1/32',
});

// INSERT_VISE_SEMI
idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI,
  size: '---',
  od: '',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI,
  size: '0: 9/16',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI,
  size: '0.5: 37/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI,
  size: '1: 19/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI,
  size: '1.5: 39/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI,
  size: '2: 5/8',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI,
  size: '2.5: 41/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI,
  size: '3: 21/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI,
  size: '3.5: 43/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI,
  size: '4: 11/16',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI,
  size: '4.5: 45/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI,
  size: '5: 23/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI,
  size: '5.5: 47/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI,
  size: '6: 3/4',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI,
  size: '6.5: 49/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI,
  size: '7: 25/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI,
  size: '7.5: 51/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI,
  size: '8: 13/16',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI,
  size: '8.5: 53/64',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI,
  size: '9: 27/32',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI,
  size: '9.5: 55/64',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI,
  size: '10: 7/8',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI,
  size: '10.5: 57/64',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI,
  size: '11: 29/32',
  od: '1 1/32',
});

// INSERT_VISE_POWER_OVAL
idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: '---',
  od: '',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: '0: 9/16',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: '0.5: 37/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: '1: 19/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: '1.5: 39/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: '2: 5/8',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: '2.5: 41/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: '3: 21/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: '3.5: 43/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: '4: 11/16',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: '4.5: 45/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: '5: 23/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: '5.5: 47/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: '6: 3/4',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: '6.5: 49/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: '7: 25/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: '7.5: 51/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: '8: 13/16',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: '8.5: 53/64',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: '9: 27/32',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: '9.5: 55/64',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: '10: 7/8',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: '10.5: 57/64',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: '11: 29/32',
  od: '1 1/32',
});

// INSERT_VISE_OVAL
idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL,
  size: '---',
  od: '',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL,
  size: '0: 9/16',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL,
  size: '0.5: 37/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL,
  size: '1: 19/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL,
  size: '1.5: 39/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL,
  size: '2: 5/8',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL,
  size: '2.5: 41/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL,
  size: '3: 21/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL,
  size: '3.5: 43/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL,
  size: '4: 11/16',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL,
  size: '4.5: 45/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL,
  size: '5: 23/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL,
  size: '5.5: 47/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL,
  size: '6: 3/4',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL,
  size: '6.5: 49/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL,
  size: '7: 25/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL,
  size: '7.5: 51/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL,
  size: '8: 13/16',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL,
  size: '8.5: 53/64',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL,
  size: '9: 27/32',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL,
  size: '9.5: 55/64',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL,
  size: '10: 7/8',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL,
  size: '10.5: 57/64',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL,
  size: '11: 29/32',
  od: '1 1/32',
});

// INSERT_VISE_SILICONE
idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SILICONE,
  size: '---',
  od: '',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SILICONE,
  size: '0: 9/16',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SILICONE,
  size: '1: 19/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SILICONE,
  size: '2: 5/8',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SILICONE,
  size: '3: 21/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SILICONE,
  size: '4: 11/16',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SILICONE,
  size: '5: 23/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SILICONE,
  size: '6: 3/4',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SILICONE,
  size: '7: 25/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SILICONE,
  size: '8: 13/16',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SILICONE,
  size: '9: 27/32',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SILICONE,
  size: '10: 7/8',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SILICONE,
  size: '11: 29/32',
  od: '1 1/32',
});

// INSERT_VISE_GRAPE_NUBS
idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: '---',
  od: '',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: '0.5: 37/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: '1: 19/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: '1.5: 39/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: '2: 5/8',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: '2.5: 41/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: '3: 21/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: '3.5: 43/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: '4: 11/16',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: '4.5: 45/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: '5: 23/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: '5.5: 47/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: '6: 3/4',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: '6.5: 49/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: '7: 25/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: '7.5: 51/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: '8: 13/16',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: '8.5: 53/64',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: '9: 27/32',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: '9.5: 55/64',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: '10: 7/8',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: '10.5: 57/64',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: '11: 29/32',
  od: '1 1/32',
});

// INSERT_VISE_POWER_LIFT_7_8
idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT_7_8,
  size: '---',
  od: '',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT_7_8,
  size: '-1: 17/32',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT_7_8,
  size: '-0.5: 35/64',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT_7_8,
  size: '0: 9/16',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT_7_8,
  size: '0.5: 37/64',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT_7_8,
  size: '1: 19/32',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT_7_8,
  size: '1.5: 39/64',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT_7_8,
  size: '2: 5/8',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT_7_8,
  size: '2.5: 41/64',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT_7_8,
  size: '3: 21/32',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT_7_8,
  size: '3.5: 43/64',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT_7_8,
  size: '4: 11/16',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT_7_8,
  size: '4.5: 45/64',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT_7_8,
  size: '5: 23/32',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT_7_8,
  size: '5.5: 47/64',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT_7_8,
  size: '6: 3/4',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT_7_8,
  size: '6.5: 49/64',
  od: '7/8',
});

// INSERT_VISE_POWER_OVAL_7_8
idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL_7_8,
  size: '---',
  od: '',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL_7_8,
  size: '-1: 17/32',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL_7_8,
  size: '-0.5: 35/64',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL_7_8,
  size: '0: 9/16',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL_7_8,
  size: '0.5: 37/64',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL_7_8,
  size: '1: 19/32',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL_7_8,
  size: '1.5: 39/64',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL_7_8,
  size: '2: 5/8',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL_7_8,
  size: '2.5: 41/64',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL_7_8,
  size: '3: 21/32',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL_7_8,
  size: '3.5: 43/64',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL_7_8,
  size: '4: 11/16',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL_7_8,
  size: '4.5: 45/64',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL_7_8,
  size: '5: 23/32',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL_7_8,
  size: '5.5: 47/64',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL_7_8,
  size: '6: 3/4',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL_7_8,
  size: '6.5: 49/64',
  od: '7/8',
});

// INSERT_VISE_SEMI_7_8
idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI_7_8,
  size: '---',
  od: '',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI_7_8,
  size: '-1: 17/32',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI_7_8,
  size: '-0.5: 35/64',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI_7_8,
  size: '0: 9/16',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI_7_8,
  size: '0.5: 37/64',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI_7_8,
  size: '1: 19/32',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI_7_8,
  size: '1.5: 39/64',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI_7_8,
  size: '2: 5/8',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI_7_8,
  size: '2.5: 41/64',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI_7_8,
  size: '3: 21/32',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI_7_8,
  size: '3.5: 43/64',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI_7_8,
  size: '4: 11/16',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI_7_8,
  size: '4.5: 45/64',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI_7_8,
  size: '5: 23/32',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI_7_8,
  size: '5.5: 47/64',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI_7_8,
  size: '6: 3/4',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI_7_8,
  size: '6.5: 49/64',
  od: '7/8',
});

// INSERT_VISE_OVAL_7_8
idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL_7_8,
  size: '---',
  od: '',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL_7_8,
  size: '-1: 17/32',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL_7_8,
  size: '-0.5: 35/64',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL_7_8,
  size: '0: 9/16',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL_7_8,
  size: '0.5: 37/64',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL_7_8,
  size: '1: 19/32',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL_7_8,
  size: '1.5: 39/64',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL_7_8,
  size: '2: 5/8',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL_7_8,
  size: '2.5: 41/64',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL_7_8,
  size: '3: 21/32',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL_7_8,
  size: '3.5: 43/64',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL_7_8,
  size: '4: 11/16',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL_7_8,
  size: '4.5: 45/64',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL_7_8,
  size: '5: 23/32',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL_7_8,
  size: '5.5: 47/64',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL_7_8,
  size: '6: 3/4',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL_7_8,
  size: '6.5: 49/64',
  od: '7/8',
});

// INSERT_ULTIMATE_TLO_OVAL
idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: '---',
  od: '',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: '9/16',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: '37/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: '19/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: '39/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: '5/8',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: '41/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: '21/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: '43/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: '11/16',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: '45/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: '23/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: '47/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: '3/4',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: '49/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: '25/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: '51/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: '13/16',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: '53/64',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: '27/32',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: '55/64',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: '7/8',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: '57/64',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: '29/32',
  od: '1 1/32',
});

// INSERT_ULTIMATE_TLO_LIFT
idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: '---',
  od: '',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: '9/16',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: '37/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: '19/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: '39/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: '5/8',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: '41/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: '21/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: '43/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: '11/16',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: '45/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: '23/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: '47/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: '3/4',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: '49/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: '25/32',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: '51/64',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: '13/16',
  od: '31/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: '53/64',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: '27/32',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: '55/64',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: '7/8',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: '57/64',
  od: '1 1/32',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: '29/32',
  od: '1 1/32',
});

// INSERT_ULTIMATE_TLO_OVAL_7_8
idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL_7_8,
  size: '---',
  od: '',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL_7_8,
  size: '17/32',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL_7_8,
  size: '9/16',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL_7_8,
  size: '19/32',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL_7_8,
  size: '5/8',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL_7_8,
  size: '21/32',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL_7_8,
  size: '11/16',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL_7_8,
  size: '23/32',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL_7_8,
  size: '3/4',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL_7_8,
  size: '25/32',
  od: '7/8',
});

// INSERT_ULTIMATE_TLO_LIFT_7_8
idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT_7_8,
  size: '---',
  od: '',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT_7_8,
  size: '17/32',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT_7_8,
  size: '9/16',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT_7_8,
  size: '19/32',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT_7_8,
  size: '5/8',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT_7_8,
  size: '21/32',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT_7_8,
  size: '11/16',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT_7_8,
  size: '23/32',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT_7_8,
  size: '3/4',
  od: '7/8',
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT_7_8,
  size: '25/32',
  od: '7/8',
});

export const idx_data_insert_sizes = R.map(size =>
  R.pipe(
    R.assocPath(['size'], R.trim(R.path(['size'], size))),
    R.assocPath(['od'], R.trim(R.path(['od'], size)))
  )(size)
)(idx_data_insert_sizesRAW);
